import { NavLink } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";
import logo from "../assets/images/logo.svg";

export function Navigation() {
    return (
        <div className="container padding-left-none padding-right-none">
              <nav className="navbar navbar-expand-lg navbar-dark">
                <div className="container-fluid">
                  <a className="navbar-brand" href="/">
                    <h1><img src={logo} alt="Zayne Browning" /></h1>
                  </a>
                  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav ms-auto flex-nowrap">
                      <li className="nav-item">
                        <HashLink to="#music" className="nav-link">Music</HashLink>
                      </li>
                      <li className="nav-item">
                        <HashLink to="#upcomingShows" className="nav-link">Upcoming Shows</HashLink>
                      </li>
                      <li className="nav-item">
                        <HashLink to="#bookings" className="nav-link">Bookings</HashLink>
                      </li>
                      <li className="nav-item">
                        <HashLink to="#photos" className="nav-link">Photos</HashLink>
                      </li>
                    </ul>
                    <ul className="navbar-nav ms-auto flex-nowrap">
                      <li className="nav-item">
                        <NavLink to="https://www.facebook.com/profile.php?id=61571021617557" target="_blank" className="nav-link"><i className="fa-brands fa-facebook-f"></i></NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="https://www.instagram.com/zayne.______/" target="_blank" className="nav-link"><i className="fa-brands fa-instagram"></i></NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="https://www.tiktok.com/@zayne._____" target="_blank" className="nav-link"><i className="fa-brands fa-tiktok"></i></NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="https://x.com/ZayneBrowning" target="_blank" className="nav-link"><i className="fa-brands fa-x-twitter"></i></NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="https://www.youtube.com/channel/UCclSVkxU3mBJ-xnJMvxZWRw" target="_blank" className="nav-link"><i className="fa-brands fa-youtube"></i></NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
    );
}